<template>
  <div class="pageWoreArea">
    <div class="pageMain">
      <!-- top -->
      <div class="top">工作区</div>
      <!-- main -->
      <div class="main">
        <!-- title -->
        <div class="title">工作区域</div>
        <!-- list -->
        <div style="position: absolute; height: 100%">
          <el-scrollbar class="full-width" style="height: calc(100% - 200px)">
            <div class="list">
              <div
                v-for="(item, index) in listData"
                :key="index"
                class="listItem"
              >
                <div>
                  <div class="listImgs" @click.stop="detailItem(item)">
                    <img
                      :src="imgPath(item.fileCode)"
                      class="listImg"
                      onerror="this.src='/images/theme/newDark/default.png'"
                    />
                    <div class="listBtn">
                      <el-button
                        type="text"
                        v-auth="'/workorder/index:update'"
                        @click.stop="openDialog(item)"
                        class="button"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        @click.stop="detailItem(item)"
                        class="button"
                        >详情</el-button
                      >
                      <el-button
                        type="text"
                        v-auth="'/workorder/index:delete'"
                        @click.stop="delItem(item)"
                        class="button"
                        >删除</el-button
                      >
                    </div>
                  </div>
                  <div class="listTitle">
                    {{ item.workOrderWorkGroupName }}
                  </div>
                </div>
              </div>
              <div class="listItem" v-auth="'/workorder/index:add'">
                <div @click="openDialog()">
                  <div class="add iconfont-lunan icon-lunan-jia-copy"></div>
                  <p>创建</p>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      class="pageDialog"
      :visible.sync="dialogVisible"
      width="350px"
    >
      <el-form
        ref="dialogForm"
        :model="treeForm"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item prop="workOrderWorkGroupName" label="名称">
          <el-input
            placeholder="请输入名称"
            maxlength="10"
            clearable
            v-model="treeForm.workOrderWorkGroupName"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="fileCode">
          <el-upload
            action
            v-if="!fileList.length"
            :file-list="fileList"
            ref="addRosterUl"
            :show-file-list="false"
            :list-type="'picture-card'"
            accept="image/png, image/jpg, image/jpeg, image/bpm"
            :auto-upload="false"
            :multiple="false"
            :limit="1"
            :on-change="onChange"
            :on-remove="onRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="imgFile" v-else>
            <img
              :src="imageUrl"
              class="image-file"
              onerror="this.src='/images/theme/newDark/default.png'"
            />
            <div class="delete-icon">
              <i class="el-icon-delete" @click="onRemove"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      dialogTitle: "",
      imageUrl: "",
      fileList: [],
      dialogVisible: false,
      treeForm: {
        workOrderWorkGroupName: "",
        imgUrl: "",
        fileCode: "",
      },
      rules: {
        workOrderWorkGroupName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change",
          },
        ],
      },
      listData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // detail Work
    detailItem(val) {
      this.$router.push({
        path: "/workorder/workArea",
        query: {
          id: val.workOrderWorkGroupCode,
          name: val.workOrderWorkGroupName,
        },
      });
    },
    //delitem
    delItem(val) {
      this.$confirm("您确定删除该工作区么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          workOrderWorkGroupCode: val.workOrderWorkGroupCode,
        };
        this.$fetch(api.workOrder.deleteWorkOrderWorkGroup, params).then(
          (response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
            } else {
              this.$message.success("删除成功");
              this.getList();
            }
          }
        );
      });
    },
    imgPath(fileCode) {
      return fileCode
        ? utils.Bus.imgPath(fileCode)
        : "/images/theme/newDark/default.png";
    },
    // getLIST
    getList() {
      this.$fetch(api.workOrder.queryWorkOrderWorkGroup, {
        parentCode: "-1",
      }).then((res) => {
        if (res.success) {
          let result = res.returnObj;
          this.listData = [...result];
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //openDialog
    openDialog(val) {
      if (val) {
        // edit
        this.dialogTitle = "编辑";
        this.dialogVisible = true;
        this.fileList = val.fileCode ? [{ url: val.fileCode }] : [];
        this.imageUrl = val.fileCode ? utils.Bus.imgPath(val.fileCode) : "";
        Object.assign(this.treeForm, val);
      } else {
        // add
        this.dialogTitle = "新增";
        this.fileList = [];
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.dialogForm.resetFields();
        });
      }
    },
    //add/edit dialogBackcall
    submitDialog() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length && this.fileList[0].uid) {
            // 单独上传
            let formData = new FormData();
            this.fileList.map((item) => {
              formData.append("files", item.raw);
            });
            let picUrl = [];
            let pictur = "";
            this.$fetch(api.workOrder.upFile, formData).then((res) => {
              if (res.success) {
                res.returnObj.forEach((item) => {
                  picUrl.push(item.fileId);
                });
                pictur = picUrl.join(",");
                this.saveWork(pictur);
              } else {
                this.$message.error(res.msgContent);
              }
            });
          } else {
            if (this.fileList.length) {
              this.saveWork(this.fileList[0].url);
            } else {
              this.saveWork("");
            }
          }
        }
      });
    },
    // add/update Function
    saveWork(pictur) {
      let params = {
        fileCode: pictur,
        parentCode: "", //-工单工作组父节点编号
        workOrderWorkGroupName: this.treeForm.workOrderWorkGroupName, //--工单工作组名称
      };
      let url = api.workOrder.addWorkOrderWorkGroup;
      if (this.dialogTitle == "编辑") {
        delete params.parentCode;
        params.workOrderWorkGroupCode = this.treeForm.workOrderWorkGroupCode;
        url = api.workOrder.updateWorkOrderWorkGroup;
      }
      this.$fetch(url, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.dialogVisible = false;
          this.getList();
          this.$message.success("操作成功");
        }
      });
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    onChange(file, fileList) {
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      this.treeForm.fileCode = "";
      this.imageUrl = URL.createObjectURL(file.raw);
      this.fileList = fileList;
    },
    onRemove(file, fileList) {
      this.$confirm("确认要删除图片吗？", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.treeForm.fileCode = "";
        this.fileList = [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.pageWoreArea {
  height: 100%;
  width: 100%;
  position: absolute;
  .pageMain {
    margin: 20px;
    .top {
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      @include set_theme_color(background-color, item-active-bg-color);
    }
    .main {
      margin-top: 30px;
      .title {
        font-size: 16px;
        font-weight: 400;
        height: 50px;
        line-height: 50px;
        margin-bottom: 5px;
      }
      .list {
        padding: 5px 0;
        display: flex;
        flex-wrap: wrap;
        .listItem {
          width: 120px;
          height: 120px;
          border-radius: 10px;
          cursor: pointer;
          margin-right: 15px;
          margin-bottom: 25px;
          text-align: center;
          &:hover {
            // opacity: 0.8;
          }
          .listImgs {
            position: relative;
            &:hover {
              .listBtn {
                opacity: 1;
              }
            }
            .listImg {
              margin-bottom: 5px;
              border-radius: 10px;
              width: 120px;
              height: 100px;
            }
            .listBtn {
              position: absolute;
              bottom: 8px;
              // height: 100%;
              display: flex;
              width: 100%;
              opacity: 0;
              border-radius: 10px;
              flex-direction: row;
              justify-content: space-between;
              justify-content: center;
              align-items: top;
              background-color: rgba($color: #000000, $alpha: 0.7);
              border: none;
              transition: opacity 0.1s;
              .el-button {
                &:hover {
                  color: #fff;
                  font-size: 13px;
                }
              }
            }
          }

          .add {
            margin-bottom: 8px;
            border-radius: 10px;
            background: #fff;
            width: 120px;
            height: 100px;
            font-size: 40px;
            line-height: 100px;
            color: rgba(225, 225, 225, 1);
          }
        }
      }
    }
  }
  .pageDialog {
    /deep/ .el-upload {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }
    .image-file {
      width: 100px;
      height: 100px;
    }
    .imgFile {
      display: flex;
      width: 100px;
      height: 100px;
      position: relative;
      &:hover {
        .delete-icon {
          opacity: 1;
        }
      }
      .delete-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        display: flex;
        opacity: 0;
        justify-content: center;
        align-items: center;
        background-color: rgba($color: #000000, $alpha: 0.4);
        border: 1px solid #999999;
        transition: opacity 0.2s;
      }
    }
  }
}
</style>